import { Flex, Slider, Typography } from "antd";
import styled from "styled-components";
import { useTranslate } from "@refinedev/core";
import {
  MAXIMUM_STORYBOARD_VIDEO_DURATION,
  SPEECH_WORDS_PER_MINUTE,
} from "pages/media/constants";
import { secToHHMMSS } from "pages/media/utils";
import { radius } from "@libertify/ui";

const MIN_DURATION_SECONDS = 30;
const DURATION_STEP_SECONDS = 10;

export const PlaybookDurationSlider = ({
  value,
  onChange,
}: {
  value: number;
  onChange: (value: number) => void;
}) => {
  const t = useTranslate();
  const estimatedWords = Math.floor((value / 60) * SPEECH_WORDS_PER_MINUTE);

  return (
    <Flex vertical gap={20}>
      <StyledSlider
        value={value}
        min={MIN_DURATION_SECONDS}
        max={MAXIMUM_STORYBOARD_VIDEO_DURATION}
        step={DURATION_STEP_SECONDS}
        tooltip={{ open: false }}
        onChange={(next) => onChange(next)}
      />
      <StyledLabel strong>
        {secToHHMMSS(value)} ≈ {estimatedWords}{" "}
        {t("projects.components.ProjectSettingForm.words")}
      </StyledLabel>
    </Flex>
  );
};

const StyledSlider = styled(Slider)`
  margin: 6px 0;

  .ant-slider-rail {
    height: 6px;
    border-radius: ${radius.pill}px;
    background: ${({ theme }) => theme.colorBorderSecondary};
  }
  .ant-slider-track {
    height: 6px;
    border-radius: ${radius.pill}px;
    background: ${({ theme }) => theme.colorPrimary};
  }
  .ant-slider-handle::after {
    width: 16px;
    height: 16px;
    box-shadow: 0 0 0 2px ${({ theme }) => theme.colorPrimary} !important;
  }
  .ant-slider-handle:hover::after,
  .ant-slider-handle:focus::after {
    box-shadow: 0 0 0 2px ${({ theme }) => theme.colorPrimary} !important;
  }
`;

const StyledLabel = styled(Typography.Text)`
  color: ${({ theme }) => theme.colorPrimary};
`;
